/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Helpers_TInputs */



/**
* | output |
* | --- |
* | "Do not run it alone" |
*
* @param {Tournament_Wiz_Tip_Helpers_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_helpers_t = /** @type {((inputs?: Tournament_Wiz_Tip_Helpers_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Helpers_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne le gérez pas seul")
	if (locale === "es") return /** @type {LocalizedString} */ ("No lo lleve solo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não toque o evento sozinho")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non gestirlo da solo")
	return /** @type {LocalizedString} */ ("Do not run it alone")
});